/**
 * Partner workspaces (11-04, Adam: "I need to see my partner portals and what the partners are seeing"). LiveEcho and
 * 6 Hands Media each have their own workspace and portal address; Adam is a member of both. From ARC's Clients he sees each
 * one's clients in a drop-down (routes/clients.tsx) and opens them exactly as their team sees them. Inside one, a strip says
 * whose workspace it is and leads back.
 */
import { useQuery } from '@tanstack/react-query';
import { authClient, rememberOrg } from '../auth.ts';
import './partners.css';

type Workspace = { id: string; name: string; role: string; current: boolean; portal: { origin: string; brand: string } | null;
  clients?: string[]; team?: { name: string; role: string; signedIn: boolean }[] };
const host = (o: string) => o.replace(/^https?:\/\//, '');

export const useWorkspaces = () => useQuery({ queryKey: ['workspaces'], staleTime: 60_000,
  queryFn: async () => { const r = await fetch('/api/v1/workspaces', { credentials: 'include' }); return r.ok ? (await r.json()) as Workspace[] : []; } });

export async function openIn(id: string, to = '/') {
  const r = await authClient.organization.setActive({ organizationId: id });
  if (r.error) return;
  rememberOrg(id);
  window.location.assign(to);
}

/** Inside a partner's workspace: whose it is, where their team sees it, and the way back. */
export function PartnerBanner() {
  const q = useWorkspaces();
  const here = q.data?.find((w) => w.current);
  const home = q.data?.find((w) => !w.portal);
  if (!here?.portal || !home) return null;
  return (
    <div className="pw-banner" role="status" data-testid="partner-banner">
      <span>You’re in <b>{here.portal.brand}</b>’s workspace: what their team sees, under their own name at <a href={here.portal.origin} target="_blank" rel="noreferrer">{host(here.portal.origin)}</a>.</span>
      <button type="button" className="cx-btn cx-btn--sm" onClick={() => void openIn(home.id, '/clients')} data-testid="partner-back">Back to {home.name}</button>
    </div>
  );
}
